import styles from "./AppHeader.module.scss";
import { HeadSearch } from "../enhancedSearch/HeadSearch/HeadSearch";
import { useNavigate, useLocation } from "react-router-dom";
import useScreenSize from "../../hooks/useScreenSize";
import useAppModernisation from "../../hooks/useAppModernisation";
import OnlineIcon from "../../assets/icons/AccountWeb.svg?react";
import { Link } from "react-router-dom";
import AppsMenu from "../AppsMenu/AppsMenu";
import useAuth from "../../hooks/useAuth";
import useNetworkStatus from "../../hooks/useNetworkStatus";

import { ModernBreadcrumb } from "../Breadcrumbs";

const AppHeader = () => {
  const push = useNavigate();
  const { isDesktop } = useScreenSize();
  const hookResult = useAppModernisation() || {};
  const { isAppMode } = hookResult;
  const location = useLocation();
  const {
    // isInstitution,
    subscriptionDetails,
    isLoading = false,
    subscriptionError = null,
    subscriptionCheckAttempted = false,
  } = useAuth();
  const { isOnline } = useNetworkStatus();
  const shouldShowApps =
    !isLoading &&
    !subscriptionError &&
    !!subscriptionDetails &&
    subscriptionCheckAttempted &&
    !subscriptionDetails.isMultiUser &&
    !isAppMode &&
    isOnline;
  // Only render breadcrumb on topic pages
  const isTopicPage =
    location.pathname.includes("/viewTopic") || location.search.includes("topicfile=");

  return (
    <>
      <div className={styles.appHeader}>
        <HeadSearch
          classicView={true}
          {...{
            push,
            isDesktop,
            isAppMode,
            searchQuery: location.search,
          }}
        />
        <></>
        <div className={styles.accountSection}>
          {shouldShowApps && <AppsMenu iconSize={32} />}
          <Link
            data-testid="account-person"
            to="/app/accountLanding"
            className={styles.accountLink}
          >
            <OnlineIcon className={styles.accountIcon} />
          </Link>
        </div>
      </div>
      {/* Only render breadcrumb on topic pages - guideline pages have their own breadcrumb */}
      {isTopicPage && <ModernBreadcrumb />}
    </>
  );
};

export default AppHeader;
